export enum Type {
  BATTLE = 'BATTLE',
  TOURNAMENT = 'TOURNAMENT'
}

export type Props = {
  type: Type;
  small?: boolean;
};
